<template>
    <div class="sharing" :style="getStylePosition" v-if="!webViewMode">
    <div class="sharing-container">
        <ShareNetwork
            network="vk"
            :url="link"
            :title="title"
            :description="description"
            :quote="title"
            :media="media"
            hashtags="wildwood"
        >
        <div class="sharing__item">
            <img src="@/assets/images/socials/vk.svg" />
        </div>
        </ShareNetwork>
        <ShareNetwork
            network="facebook"
            :url="link"
            :title="title"
            :description="description"
            :quote="title"
            :media="media"
            hashtags="wildwood"
        >
            <div class="sharing__item">
            <img src="@/assets/images/socials/facebook.svg" />
            </div>
        </ShareNetwork>
        <ShareNetwork
            network="twitter"
            :url="link"
            :title="title"
            :description="description"
            :quote="title"
            :media="media"
            hashtags="wildwood"
        >
        <div class="sharing__item">
            <img src="@/assets/images/socials/twitter.svg" />
        </div>
        </ShareNetwork>
        <ShareNetwork
            network="telegram"
            :url="link"
            :title="title"
            :description="description"
            :quote="title"
            hashtags="wildwood"
        >
        <div class="sharing__item">
            <img src="@/assets/images/socials/telegram.svg" />
        </div>
        </ShareNetwork>
        <ShareNetwork
            network="reddit"
            :url="link"
            :title="title"
            :quote="title"
            :media="media"
            hashtags="wildwood"
        >
        <div class="sharing__item">
            <img src="@/assets/images/socials/reddit.svg" />
        </div>
        </ShareNetwork>
    </div>
</div>
</template>
<script>
export default {
    name: 'Sharing',
    props: {
        link: {
            type: String,
            require: true
        },
        title: {
            type: String,
            require: true
        },
        description: {
            type: String,
            require: true
        },
        position: {
            type: String,
            require: false
        },
        media: {
            type: String,
            require: false
        }
    },
    computed: {
        getStylePosition () {
            return this.position === 'top' 
                ? {bottom: 'calc(100% + 10px)'}
                : {top: 'calc(100% + 10px)'}
        },
        webViewMode () {
            return this.$store.getters.webViewMode
        }
    },
    methods: {
        shareWebView() {
            window.ReactNativeWebView.postMessage(JSON.stringify({method: 'share', params: {
                link: this.link,
                title: this.title,
                description: this.description,
                position: this.position,
                media: this.media,
            }}))
        }
    },
    async mounted () {
        this.webViewMode ? this.shareWebView() : ''
    }
}
</script>
<style lang="stylus" scoped>
.sharing
    position absolute
    display flex
    align-items center
    left 0
    box-shadow 0 0 15px rgba(0,0,0,0.2)
    padding 7px 10px
    border-radius 20px
    background white
    +to-width(640px)
        left initial
        right 0

    &-container
        display flex
        align-items center

    &__item
      width 32px
      margin 5px
      cursor pointer
      img, svg
        max-width 100%
</style>